import { ReactComponent as HomeHeaderIcon } from 'assets/images/headerNavigation/bx-home-circle.svg';
import { ReactComponent as PriceAvailabilityHeaderIcon } from 'assets/images/headerNavigation/bx-calendar.svg';
import { ReactComponent as LocationHeaderIcon } from 'assets/images/headerNavigation/Buildings.svg';
import { ReactComponent as PromotionIcon } from 'assets/images/headerNavigation/promotion-logo.svg';
import { ReactComponent as ReviewIcon } from 'assets/images/headerNavigation/Star.svg';
import { ReactComponent as FinanceIcon } from 'assets/images/headerNavigation/finance.svg';
import { ReactComponent as AnalysisHeaderIcon } from 'assets/images/headerNavigation/analytics-icon.svg';
import { ReactComponent as BookingListIcon } from 'assets/images/headerNavigation/bx-file.svg';
import { ReactComponent as MailBoxIcon } from 'assets/images/headerNavigation/mail-box.svg';
import { LOCATIONS } from 'constants/index';

const headerExtranetNavigation = [
  {
    link: LOCATIONS.DASHBOARD,
    name: 'header.navigation.home',
    icon: HomeHeaderIcon,
    notificationKey: 'homepage',
  },
  {
    name: 'header.navigation.price_room_status',
    permissionKey: 'price',
    icon: PriceAvailabilityHeaderIcon,
    children: [
      {
        name: 'header.navigation.calendar',
        link: LOCATIONS.LOCATION_DETAIL.DETAIL_CALENDAR,
      },
      {
        name: 'header.navigation.price_type',
        link: LOCATIONS.LOCATION_DETAIL.LIST_PRICE_TYPE,
      },
      {
        name: 'header.navigation.open_close_room',
        link: LOCATIONS.LOCATION_DETAIL.OPEN_CLOSE_ROOM,
      },
      {
        name: 'header.navigation.update_sales_room',
        link: LOCATIONS.LOCATION_DETAIL.UPDATE_AMOUNT_ROOM,
      },
      {
        name: 'header.navigation.update_selling_price',
        link: LOCATIONS.LOCATION_DETAIL.UPDATE_PRICE,
      },
    ],
  },
  {
    link: LOCATIONS.LOCATION_DETAIL.PROMOTION,
    name: 'header.navigation.promotion',
    permissionKey: 'promotion',
    icon: PromotionIcon,
  },
  {
    name: 'header.navigation.accommodation',
    permissionKey: 'place',
    icon: LocationHeaderIcon,
    children: [
      {
        name: 'header.navigation.general',
        link: LOCATIONS.LOCATION_DETAIL.DEFAULT,
      },
      {
        name: 'header.navigation.policy',
        link: LOCATIONS.LOCATION_DETAIL.POLICY,
      },
      {
        name: 'header.navigation.cancellation_policy',
        link: LOCATIONS.LOCATION_DETAIL.CANCELLATION_POLICY,
      },
      {
        name: 'header.navigation.conveniences_services',
        link: LOCATIONS.LOCATION_DETAIL.CONVENIENCE_SERVICE,
      },
      {
        name: 'header.navigation.location',
        link: LOCATIONS.LOCATION_DETAIL.NEAR_LOCATION,
      },
      {
        name: 'header.navigation.picture',
        link: LOCATIONS.LOCATION_DETAIL.DETAIL_PICTURE,
      },
      {
        name: 'header.navigation.room_type',
        link: LOCATIONS.LOCATION_DETAIL.ROOMS_OF_PLACE,
      },
      {
        name: 'header.navigation.room_amenities',
        link: LOCATIONS.LOCATION_DETAIL.CONVENIENCE_ROOM,
      },
      {
        name: 'header.navigation.contact',
        link: LOCATIONS.LOCATION_DETAIL.CONTACT_INFORMATION,
      },
      {
        name: 'header.navigation.contract',
        link: LOCATIONS.CONTRACT,
      },
      {
        name: 'header.navigation.vat_service',
        link: LOCATIONS.LOCATION_DETAIL.VAT_SERVICE,
      },
    ],
  },
  {
    link: LOCATIONS.LOCATION_DETAIL.MANAGER_BOOKING,
    name: 'header.navigation.manager_booking',
    permissionKey: 'booking',
    icon: BookingListIcon,
    notificationKey: 'booking',
  },
  {
    link: LOCATIONS.LOCATION_DETAIL.MESSAGES_WITH_CUSTOMERS,
    name: 'header.navigation.mailbox',
    permissionKey: 'mailbox',
    icon: MailBoxIcon,
    notificationKey: 'mail',
  },
  // {
  //   name: 'header.navigation.mailbox',
  //   permissionKey: 'mailbox',
  //   icon: MailBoxIcon,
  //   notificationKey: 'mail',
  //   children: [
  //     {
  //       name: 'header.navigation.message_with_customer',
  //       link: LOCATIONS.LOCATION_DETAIL.MESSAGES_WITH_CUSTOMERS,
  //     },
  //     {
  //       name: 'header.navigation.message_with_bookese',
  //       link: LOCATIONS.DASHBOARD,
  //     },
  //   ],
  // },
  {
    link: LOCATIONS.LOCATION_DETAIL.FINANCE,
    name: 'header.navigation.finance',
    permissionKey: 'finance',
    icon: FinanceIcon,
    notificationKey: 'finance',
  },
  {
    link: LOCATIONS.LOCATION_DETAIL.DETAIL_REVIEWS,
    name: 'header.navigation.review',
    permissionKey: 'review',
    icon: ReviewIcon,
    notificationKey: 'review',
  },

  {
    link: LOCATIONS.LOCATION_DETAIL.ANALYSIS_OVERVIEW,
    name: 'header.navigation.analysis',
    permissionKey: 'analytic',
    icon: AnalysisHeaderIcon,
  },
];

export default headerExtranetNavigation;
